import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CommonStructured from "../../common-components/CommonStructured";
import CmnFilters from "../common/CmnFilters";
import { fetchWalkinLeadsData } from "../../../redux/prospect-reducers/prospectSlice";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import {
  convertTo12HourFormat,
  formatDateTime,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import LeadFollowupV1 from "../followup/LeadFollowupV1";
import AddLeadForm from "../AddLeadForm";
import WalkinsForm from "./WalkinsForm";
import MemberRatings from "./MemberRatings";
import WalkinsListingsMobile from "./WalkinsListingsMobile";
import LeadJourney from "../lms-v2/lead-journey/LeadJourney";
import { isDev } from "../../common-data/Commons";
import { isBroadcastCreateAllowedEmail } from "../../common-data/Accessibles";
import CommonBroadForm from "../../common-components/broadcast-template/CommonBroadForm";
import "../../../styles/lead-mangement/walkins.css";
import {
  EyeIcon,
  CallIcon,
  PersonIcon,
  EmailIcon,
  ExcludeIcon,
} from "../../../images/icons/icons";
import ViewDetails from "../../odm/odm-details/ViewDetails";
import ClickToCall from "../lms-v2/lms-payment-links/ClickToCall";
import CommonTable from "../../common-components/common-tables/CommonTable";

const WalkinsLead = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { walkinLeads, walkinLeadsLoading, walkinLeadsError } = useSelector(
    (state) => state.prospects
  );

  const isBroadcastCreateAllowed =
    isDev || isBroadcastCreateAllowedEmail(userInfoData?.email);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedGyms: [],
    selAssignee:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",

    selAddNotAddToLead: "",
    selectedSubmissionType: "",
    selectedGender: "",

    leadAddDateFrom: "",
    leadAddDateTo: "",

    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
    submission_type: allFilters.selectedSubmissionType?.value || "",
    assisted_by_id: allFilters.selAssignee?.value || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",
    gym_id: allFilters.selectedGym?.value || "",
    gender: allFilters.selectedGender?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const [isFilterSegmentShown, setIsFilterSegmentShown] = useState(true);

  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const isBroadcastMode = modValues.modName === "broadcast_data";

  function onCloseModal() {
    setModValues(iniModValues);
    setIsFilterSegmentShown(true);
  }

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getWalkinLeads(filters) {
    dispatch(
      fetchWalkinLeadsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getWalkinLeads(filters);
  }, [filters]);

  useEffect(() => {
    setAllFilters((prev) => {
      if (!prev.selectedGym) return prev;

      const filtered = prev.selectedGyms.filter(
        (gym) => gym?.value !== prev.selectedGym?.value
      );

      return {
        ...prev,
        selectedGyms: [prev.selectedGym, ...filtered],
      };
    });
  }, [allFilters.selectedGym]);

  useEffect(() => {
    const extractGyms = (arr) => {
      let gyms = [];

      arr?.length > 0 &&
        arr.forEach((item) => {
          const itemValue = item.value;
          gyms.push(itemValue);
        });

      return {
        gyms: gyms.join(", "),
      };
    };

    const shouldUseMultipleGyms = isBroadcastMode;
    const { gyms } = shouldUseMultipleGyms
      ? extractGyms(allFilters.selectedGyms)
      : { gyms: "" };
    const gymId = shouldUseMultipleGyms
      ? gyms || allFilters.selectedGym?.value || ""
      : allFilters.selectedGym?.value || "";

    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
      submission_type: allFilters.selectedSubmissionType?.value || "",
      assisted_by_id: allFilters.selAssignee?.value || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",
      gym_id: gymId,
      gender: allFilters.selectedGender?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.selectedSubmissionType,
    allFilters.selAssignee,
    allFilters.selAddNotAddToLead,
    allFilters.selectedGym,
    allFilters.selectedGyms,
    allFilters.selectedGender,
    isBroadcastMode,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (
      !walkinLeadsLoading &&
      !walkinLeadsError &&
      walkinLeads?.status &&
      walkinLeads?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: walkinLeads.data,
        pagination:
          walkinLeads?.pagination?.length > 0 ? walkinLeads.pagination : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [walkinLeadsLoading, walkinLeadsError, walkinLeads]);

  const tbColumns = [
    {
      dataField: "added_to_lead",
      text: "Action",
      formatter: (_, row) => (
        <div className="pp-employee-payroll-actions">
          {row?.added_to_lead ? (
            <button
              key="view"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "view-lead-journey",
                }))
              }
            >
              <EyeIcon />
              View Lead
            </button>
          ) : (
            <button
              key="add-to-lmd"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "add-to-lead",
                }))
              }
            >
              <ExcludeIcon />
              Add To LMS
            </button>
          )}

          <button
            key="click-to-call"
            type="button"
            className="pp-employee-payroll-action-button pp-outlined-border"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "click-to-call",
                rowData: row,
              }))
            }
          >
            <CallIcon color="#000" />
            click to call
          </button>
        </div>
      ),
    },
    {
      dataField: "uid",
      text: "member info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "view_details",
                  rowData: row,
                  from: "wati",
                }))
              }
            >
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data tb-link">{row?.name || "NA"}</span>
            </div>

            {row?.mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.mobile || "NA"}</span>
              </div>
            )}

            {row?.email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">{row.email || "NA"}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "gender",
      text: "gender",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gender || "NA"}</span>;
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 45;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "assisted_by",
      text: "assisted by",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.assisted_by_name || "NA"}</span>
            </div>

            {row?.assisted_by_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">
                  {row.assisted_by_mobile || "NA"}
                </span>
              </div>
            )}

            {row?.assisted_by_email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">
                  {row.assisted_by_email || "NA"}
                </span>
              </div>
            )}

            {row?.account_type && (
              <span className="tb-data tb-badge tb-badge-success-1">
                {row?.account_type?.replace(/_/g, " ") || ""}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "submission_type",
      text: "submission type",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.submission_type || "NA"}</span>;
      },
    },
    {
      dataField: "visit_start_time",
      text: "visit time",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.visit_start_time
              ? convertTo12HourFormat(row.visit_start_time)
              : "-"}{" "}
            -{" "}
            {row?.visit_end_time
              ? convertTo12HourFormat(row.visit_end_time)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "remarks",
      text: "remarks",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${row?.remarks ? "tb-link" : ""}`}
            onClick={() =>
              row?.remarks &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                modName: "remarks",
              }))
            }
          >
            {row?.remarks ? "read" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "ratings",
      text: "ratings",
      formatter: (_, row) => {
        const hasRatings = row?.ratings && row.ratings !== "{}";

        return (
          <span
            className={`tb-data ${hasRatings ? "tb-link" : ""}`}
            onClick={() =>
              hasRatings &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                modName: "ratings",
              }))
            }
          >
            {hasRatings ? "view" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer  ${
            modValues.modName === "add"
              ? "mod-width-50p mod-height-95vh"
              : modValues.modName === "add-to-lead"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.modName === "remarks" ||
                modValues.modName === "ratings"
              ? "mod-width-50p"
              : modValues.modName === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : ""
          } ${
            modValues.modName === "broadcast_data"
              ? "mod-height-95vh broadcast-modal"
              : ""
          } ${
            modValues.modName === "view_details"
              ? "mod-width-50p mod-height-95vh view-detail-modal"
              : ""
          } ${
            modValues.modName === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : ""
          }`}
        >
          {modValues.modName === "add-to-lead" ||
          modValues.modName === "click-to-call" ? null : (
            <ModalHeadAndClose
              title={
                modValues.modName === "add"
                  ? "Add New Walkin Lead"
                  : modValues.modName === "view-lead-journey"
                  ? `Lead Details - ${
                      modValues.rowData?.user_name ||
                      modValues.rowData?.name ||
                      ""
                    }`
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />
          )}

          {modValues.modName === "remarks" ? (
            <div className="discussionModalMessage mt30">
              <p className="message">
                {modValues.rowData?.remarks || "No Content Available"}
              </p>
            </div>
          ) : modValues.modName === "view-lead-journey" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "follow-up" ? (
            <LeadFollowupV1
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeFollowupModal={onCloseModal}
              //   isAllLeadDetails={true}
              pageName={"walkins"}
              prevFilters={(({ limit, page, added_to_lead, ...rest }) => rest)(
                filters
              )}
            />
          ) : modValues.modName === "add-to-lead" ? (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={() => getWalkinLeads(filters)}
              rowData={modValues.rowData}
              clickedCard={"walkins"}
              isWalkin={true}
            />
          ) : modValues.modName === "add" ? (
            <WalkinsForm
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={() => getWalkinLeads(filters)}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "ratings" ? (
            <MemberRatings rowData={modValues.rowData} />
          ) : modValues.modName === "view_details" ? (
            <ViewDetails
              rowData={modValues.rowData}
              from={modValues.from}
              userInfoData={userInfoData}
              isTimeline={true}
            />
          ) : modValues.modName === "click-to-call" ? (
            <ClickToCall
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "broadcast_data" ? (
            <>
              {isFilterSegmentShown && (
                <CmnFilters
                  from="walkins-leads"
                  isSegment={true}
                  userInfoData={userInfoData}
                  searchFilterApplied={searchFilterApplied}
                  filters={allFilters}
                  setFilters={setAllFilters}
                  onClickReset={onResetFilters}
                  isLoading={walkinLeadsLoading}
                />
              )}

              <CommonBroadForm
                from={modValues.from}
                filters={filters}
                userInfoData={userInfoData}
                closeModal={onCloseModal}
                setIsFilterSegmentShown={setIsFilterSegmentShown}
                allFilters={allFilters}
              />
            </>
          ) : null}
        </div>
      </Modal>

      <CommonStructured
        pageHeading={"Walkin Leads"}
        isReload={() => getWalkinLeads(filters)}
        createBtnTxt={"+ Add New Walkin Lead"}
        onClickCreateBtn={() =>
          setModValues((prevs) => ({
            ...prevs,
            isModOpen: true,
            modName: "add",
          }))
        }
      />

      <CmnFilters
        from="walkins-leads"
        userInfoData={userInfoData}
        searchFilterApplied={searchFilterApplied}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        onClickReset={onResetFilters}
        isLoading={walkinLeadsLoading}
        searchPlaceHolder="Search by lead name..."
        onClickBroadcastBtn={
          isBroadcastCreateAllowed
            ? () =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "broadcast_data",
                  from: "walkins",
                }))
            : null
        }
      />

      <div className="common-table-container tb-bordered hideMobile mt15">
        <CommonTable
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={walkinLeadsLoading}
        />
      </div>

      {/* <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile mt30">
        {walkinLeadsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div> */}

      <div className="lead-logs-card-container only-mobile">
        {walkinLeadsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <WalkinsListingsMobile
            tableData={allDatas.allData}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setModValues={setModValues}
          />
        )}
      </div>
    </>
  );
};

export default WalkinsLead;
